import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path class="st0" d="M12.97,3.23c-0.23,0-0.43,0.01-0.62,0c-0.13-0.01-0.2,0.04-0.24,0.16c-2.08,5.72-4.17,11.44-6.25,17.16
		c-0.02,0.06-0.04,0.12-0.07,0.21c0.21,0,0.4-0.02,0.58,0c0.17,0.02,0.24-0.06,0.3-0.21c1.92-5.29,3.85-10.58,5.77-15.86
		C12.62,4.22,12.79,3.73,12.97,3.23z M11.62,3.23c-0.22,0-0.41,0.01-0.6,0c-0.16-0.02-0.22,0.05-0.28,0.2
		C8.76,8.88,6.78,14.34,4.79,19.79c-0.11,0.32-0.23,0.64-0.35,0.98c0.21,0,0.4-0.01,0.59,0c0.16,0.01,0.23-0.03,0.29-0.19
		c1.86-5.13,3.73-10.27,5.6-15.4C11.16,4.54,11.39,3.9,11.62,3.23z M10.28,3.23c-0.23,0-0.43,0.01-0.63,0
		C9.52,3.22,9.46,3.27,9.42,3.4C7.33,9.12,5.25,14.85,3.17,20.57c-0.02,0.06-0.03,0.11-0.07,0.2c0.2,0,0.38-0.02,0.55,0
		c0.19,0.02,0.27-0.05,0.34-0.23C5.92,15.2,7.88,9.86,9.82,4.51C9.97,4.09,10.12,3.68,10.28,3.23z M13.16,4.12
		c-0.11,0.29-0.18,0.54-0.29,0.78c-0.07,0.16-0.05,0.29,0.02,0.44c1.84,3.92,3.66,7.84,5.49,11.76c0.54,1.16,1.09,2.34,1.64,3.5
		c0.02,0.06,0.09,0.15,0.14,0.15c0.25,0.02,0.48,0.01,0.76,0.01C18.32,15.21,15.75,9.68,13.16,4.12z M12.52,5.78
		c-0.11,0.29-0.19,0.54-0.29,0.79c-0.07,0.15-0.05,0.28,0.02,0.43c1.53,3.29,3.07,6.57,4.6,9.86c0.58,1.25,1.16,2.49,1.75,3.74
		c0.03,0.07,0.1,0.16,0.15,0.16c0.24,0.02,0.48,0.01,0.76,0.01C17.18,15.76,14.85,10.79,12.52,5.78z M11.83,7.55
		c-0.11,0.3-0.21,0.57-0.3,0.83c-0.05,0.12-0.04,0.22,0.01,0.34c0.93,1.99,1.86,3.99,2.8,5.99c0.92,1.96,1.83,3.93,2.75,5.89
		c0.03,0.07,0.08,0.16,0.13,0.16c0.25,0.02,0.5,0.01,0.78,0.01C15.94,16.35,13.89,11.97,11.83,7.55z"/>
	<path d="M12.97,3.23c-0.18,0.51-0.35,0.98-0.53,1.47c-1.92,5.28-3.85,10.57-5.77,15.86c-0.06,0.16-0.12,0.23-0.3,0.21
		c-0.18-0.02-0.37,0-0.58,0c0.02-0.08,0.04-0.15,0.07-0.21c2.08-5.72,4.17-11.44,6.25-17.16c0.05-0.13,0.11-0.17,0.24-0.16
		C12.54,3.24,12.74,3.23,12.97,3.23z"/>
	<path d="M11.62,3.23c-0.24,0.66-0.48,1.3-0.71,1.94c-1.87,5.13-3.74,10.27-5.6,15.4c-0.06,0.16-0.13,0.21-0.29,0.19
		c-0.19-0.01-0.38,0-0.59,0c0.12-0.34,0.24-0.66,0.35-0.98c1.98-5.45,3.97-10.91,5.95-16.36c0.06-0.15,0.11-0.21,0.28-0.2
		C11.21,3.24,11.4,3.23,11.62,3.23z"/>
	<path d="M10.28,3.23c-0.16,0.44-0.31,0.86-0.46,1.28C7.88,9.86,5.92,15.2,3.99,20.54c-0.07,0.18-0.15,0.25-0.34,0.23
		c-0.17-0.02-0.35,0-0.55,0c0.02-0.08,0.04-0.14,0.07-0.2C5.25,14.85,7.33,9.12,9.42,3.4c0.04-0.12,0.1-0.18,0.24-0.16
		C9.85,3.24,10.06,3.23,10.28,3.23z"/>
	<path d="M13.16,4.12c2.59,5.56,5.17,11.09,7.76,16.64c-0.28,0-0.52,0.01-0.76-0.01c-0.05,0-0.11-0.09-0.14-0.15
		c-0.55-1.16-1.09-2.34-1.64-3.5c-1.83-3.92-3.66-7.84-5.49-11.76c-0.07-0.16-0.09-0.29-0.02-0.44C12.97,4.66,13.05,4.41,13.16,4.12
		z"/>
	<path d="M12.52,5.78c2.34,5.01,4.66,9.98,6.99,14.98c-0.28,0-0.52,0.01-0.76-0.01c-0.06,0-0.11-0.1-0.15-0.16
		c-0.58-1.25-1.16-2.49-1.75-3.74c-1.53-3.29-3.07-6.58-4.6-9.86c-0.07-0.15-0.08-0.28-0.02-0.43C12.33,6.32,12.41,6.07,12.52,5.78z
		"/>
	<path d="M11.83,7.55c2.06,4.41,4.1,8.8,6.16,13.21c-0.28,0-0.53,0.01-0.78-0.01c-0.05,0-0.1-0.1-0.13-0.16
		c-0.92-1.96-1.84-3.93-2.75-5.89c-0.93-2-1.86-3.99-2.8-5.99c-0.06-0.12-0.06-0.22-0.01-0.34C11.63,8.11,11.72,7.85,11.83,7.55z"/>
</g>    </svg>
    </SvgIcon>
  )
}
